

















































import {Component, Mixins} from 'vue-property-decorator';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {ClaimOption} from 'supporter';

@Component({
  components: {
    CompSelectBox
  }
})
export default class ReleaseProduct extends Mixins(AmountMixin){
  private exchangeOption: null | ClaimOption = null

  created(){
    this.setReleaseProduct()
  }

  private setReleaseProduct(){
    this.exchangeOption = this.claimNoResponseData.exchangeOption;
  }
}
